module.exports = __webpack_public_path__ + "media/images/pic/hero/saska-kepa-9de4da64c4c96aa21a65cfe8cc12f198.png";